import type { SVGProps } from "react";
// generated from Chart.svg — do not edit manually
// prettier-ignore
export default function Chart(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 22 12 C 22 6.4772 17.523 2 12 2 M 22 12 C 22 17.5228 17.523 22 12 22 C 6.477 22 2 17.5228 2 12 C 2 6.4772 6.477 2 12 2 M 22 12 H 12 V 2" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
